import type { FC } from 'react';

import { Text } from '@opendoor/atoms/text';
import { Link } from 'platform/atoms';
import { HOMEPAGE_URL } from 'shared/helpers/globals';
import { GenericErrorPage } from 'shared/routes/errors/GenericErrorPage';

/**
 * A page to display when a route is not found.
 *
 * TODO: maybe use www.opendoor.com/404 error page?
 */
export const NotFoundPage: FC<{ default?: boolean }> = () => (
  <GenericErrorPage reason="not-found" causedBy="user-error" headerContent="Sorry, page not found">
    <Text as="p" className="text-body-md text-center">
      Click{' '}
      <Link
        analyticsName="homepage-404-redirect"
        className="inline"
        href={HOMEPAGE_URL}
        target="_self"
        aria-label="Go to homepage"
      >
        here
      </Link>{' '}
      to head home.
    </Text>
  </GenericErrorPage>
);
